// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/copy-check.js';

import { paths } from '../generated/copy-check';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('copy-check', Original, paths);
